module.exports = __webpack_public_path__ + "static/sidali-51198fd581e5052ad64d92e1cbc31d5d.png";